export default "__VITE_ASSET__CeF_ileR__"